module.exports = __webpack_public_path__ + "img/gender-m.ccfcaa84.svg";